module.exports = {"131028001":"北辰街道","131028100":"大厂镇","131028101":"夏垫镇","131028102":"祁各庄镇","131028103":"邵府镇","131028104":"陈府镇","131028400":"河北大厂高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131028.json
// module id = 239
// module chunks = 0